<template>
  <article class="node node-type-comparison">
    <div class="article-parent-wrapper">
      <article-header :node="node" class="hidden-sm-up"></article-header>
      <div class="container article-content-wrapper">
        <div class="row">
          <div class="col-sm-4 col-12">
            <author-pane :node="node"></author-pane>
            <share-pane :node="node"></share-pane>
          </div>

          <div class="col-12 col-sm-8">
            <comparison-product-carousel :products='products' class="hidden-sm-up"></comparison-product-carousel>
            <div class="article-body-wrapper">
              <body-head :node="node"></body-head>
              <comparison-product-carousel :products='products' class="hidden-md-down"></comparison-product-carousel>
              <field-body ref="articleBody"  :body="node.body" :node="node" :bodyOptions="bodyOptions"></field-body>
            </div>
          </div>
        </div>
      </div>

      <template v-for="(product, index) in products">
        <div class="divider w-100" v-if="index===0"></div>
        <div class="container article-content-wrapper">
          <product-pane v-if="product" :id="`product-${index}`" :product="product" :key="index"></product-pane>
          <!-- <div class="col-sm-8 offset-sm-4" v-if="index === 0">
            <div class="follow-instagram">
              <a href="/"><svg-instagram-banner></svg-instagram-banner></a>
            </div>
          </div> -->
        </div>

        <div v-if="index === 1" class="container newsletter-wrapper no-article-gutter-mobile hidden-md-up">
          <div class="col-sm-8 offset-sm-4">
            <div class="newsletter-form-wrapper">
              <inline-newsletter-form :newsletterType="getNewsLetterType" :theme="'white'"></inline-newsletter-form>
            </div>
          </div>
        </div>

        <div class="divider w-100" v-if="(index+1 != products.length)"></div>
      </template>

      <div class="container">
        <div class="row">
          <div class="col-sm-4 col-12">
          </div>
          <div class="col-12 col-sm-8">
            <div class="article-body-wrapper">
              <div class="tags-wrapper">
                <tag :node="node"></tag>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="arrow-down-wrapper">
      <svg-icon-arrow-down-one></svg-icon-arrow-down-one>
    </div> -->

  </article>
</template>

<script>
  import get from 'lodash/get'
  import forEach from 'lodash/forEach'
  import clone from 'lodash/clone'

  import NodeLink from 'components/node/Link'
  import NodeLabel from 'components/node/Label.vue'
  import AuthorPane from 'components/node/AuthorPane.vue'
  import SharePane from 'components/node/SharePane.vue'
  import ProductPane from 'components/node/ProductPane.vue'
  import ArticleHeader from 'components/node/ArticleHeader.vue'
  import Tag from 'components/node/Tag.vue'
  import FieldBody from 'components/node/fields/Body.vue'
  import InlineNewsletterForm from 'components/widgets/InlineNewsletterForm.vue'
  import BodyHead from 'components/node/fields/BodyHead.vue'
  import ComparisonProductCarousel from 'components/node/comparison/ComparisonProductCarousel.vue'

  // import SvgInstagramBanner from 'static/svg/raw/instagram_banner.svg'
  import SvgIconArrowDownOne from 'static/svg/icon_arrow_down1.svg'

  import { getNewsLetterMapping } from 'mixins/utilities'
  import EventBus from 'components/helpers/event-bus'

  export default {
    name: 'comparison-body',
    props: ['nid', 'cover'],
    components: {
      AuthorPane,
      SharePane,
      ProductPane,
      NodeLink,
      NodeLabel,
      Tag,
      FieldBody,
      ArticleHeader,
      InlineNewsletterForm,
      // 'svg-instagram-banner': SvgInstagramBanner,
      SvgIconArrowDownOne,
      BodyHead,
      ComparisonProductCarousel,
    },
    computed: {
      node() {
        return this.$store.getters.node(this.nid)
      },
      getNewsLetterType() {
        return getNewsLetterMapping(get(this, 'node.sections', {}))
      },
      products() {
        const mappedProducts = []
        forEach(get(this, 'node.product_collection', []), (product) => {
          const mappedProduct = clone(product)
          mappedProduct.product = this.$store.getters.node(mappedProduct.product)
          mappedProducts.push(mappedProduct)
        })
        return mappedProducts
      },
    },
    data() {
      return {
        bodyOptions: {
          countDown: false,
          photoOverlay: true,
          inlineNewsletter: false,
        },
      }
    },
    mounted() {
      EventBus.$emit('nodeBodyMounted')
    },
  }
</script>

<style lang="scss">
  .node-type-comparison {
    .body-head .head-title {
      margin-bottom: rem-calc(33px);
    }

    .article-body {
      @include respond-to('desktop') {
        font-size: rem-calc(20);
        line-height: rem-calc(30);
      }
      @include respond-to('mobile') {
        margin-bottom: 0;
      }
      div[class$="-wrapper"] {
        margin-bottom: rem-calc(28);
        text-align: center;
      }
      iframe {
        @include respond-to('desktop') {
          margin-top: rem-calc(0);
          margin-left: auto;
          margin-right: auto;
          margin-bottom: rem-calc(32);
        }
        @include respond-to('mobile') {
          // To override inline style
          margin-top: rem-calc(0);
          margin-left: auto;
          margin-right: auto;
          margin-bottom: rem-calc(28) !important;
        }
      }
      & > *:last-child {
        margin-bottom: 0;
      }
      iframe, img {
        max-width: 100%;
      }
      img {
        height: auto;
      }
    }

    .share-buttons-wrapper .share-button svg{
      fill: $rose;
    }
  }
</style>


<style scoped lang="scss">
  .newsletter-wrapper{
    padding-top: rem-calc(12);
  }

  .divider {
    @include respond-to('desktop') {
      border-bottom: 2px solid $pastel-gray;
      padding-top: rem-calc(12);
      margin-bottom: rem-calc(12);
    }
  }

  .node-type-comparison {
    background-color: $white;

    .article-content-wrapper {
      font-family: $roboto;
    }
  }
  figcaption {
    font-size: rem-calc(14);
    line-height: rem-calc(16);
    color: $manatee2;
    margin-top: rem-calc(10);
  }

  .follow-instagram {
    text-align: center;
    @include respond-to('desktop') {
      padding-top: rem-calc(40);
    }
    svg {
      width: 100%;
    }
    a {
      display: inline-block;
    }
  }

  .article-parent-wrapper {
    @include respond-to('desktop') {
      padding-top: rem-calc(40);
    }
  }

  .article-content-wrapper {
    background-color: $white;
    color: $base-font-color;
    font-size: rem-calc(18);
    line-height: rem-calc(26);
    padding-bottom: rem-calc(28);
    @include respond-to('mobile') {
      padding-left: rem-calc($mobile-article-gutter);
      padding-right: rem-calc($mobile-article-gutter);
    }
  }

  .article-summary {
    font-weight: bold;
    @include respond-to('desktop') {
      font-size: rem-calc(24);
      line-height: rem-calc(34);
    }
  }

  .article-body-wrapper {
    @include respond-to('mobile') {
      padding-top: rem-calc(28);
    }
  }

  .tags-wrapper {
    position: relative;
    padding: rem-calc(28 7 15);
    border-top: 1px solid $manatee;
    font-family: $barlow;
  }

  .comment-wrapper {
    @include respond-to('desktop') {
      position: absolute;
      top: rem-calc(0);
      left: rem-calc(-250);
    }

    position: relative;
    margin-top: rem-calc(28);

    .comment-count {
      position: absolute;
      left: 0;
      top: 0;
      color: #FFF;
      font-size: 18px;
      line-height: 41px;
      max-width: 172px;
      width: 100%;
      text-align: center;
      text-transform: uppercase;
    }
  }

</style>



// WEBPACK FOOTER //
// ComparisonBody.vue?31294c10